import { FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class TDeclaracionSuplementariaViewModel {
    public Id: number;
    public IdCampania: number;
    public IdTipoTextoDecSuplementariaCam: number;
    public DescripcionTexto: string;
    public TextoDecSuplementaria: string;
    public FechaCreacion: Date;
    public FechaBaja: Date;
    public Observaciones: string;
    public Activa = false;
}

export class DeclaracionSuplementariaItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TDeclaracionSuplementariaItemViewModel[];
}

export class TDeclaracionSuplementariaItemViewModel {
    public Id: number;
    public IdCampaniaDescripcion: string;
    public IdPaisDescripcion: string;
    public IdTipoTextoDecSuplementariaCamDescripcion: string;
    public DescripcionTexto: string;
    public TextoDecSuplementaria: string;
    public Observaciones: string;
}

export class FilterSearchingTDeclaracionSuplementariaViewModel extends FilterSearchingBaseViewModel {
    public IdCampania: number;
    public IdPais: number;
    public Activa = false;
}
